import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

export const styles = (theme) => ({
  cardElementStyle: {
    base: {
      fontSize: 16,
      fontFamily: theme.typography.fontFamily,
      color: theme.colorPalette.green_75,
      fontWeight: 400,
      backgroundColor: theme.palette.common.white,
      '::placeholder': {
        fontSize: 16,
        color: theme.colorPalette.grey_10_op_38
      }
    },
    // Prevent completed-field text rendering blue (SDK switches to this variant on valid input).
    complete: {
      color: theme.colorPalette.green_75
    },
    invalid: {
      color: theme.palette.error.main
    }
  }
});

const materialStyles = (theme) => ({
  '@global': {
    '#CARD_ELEMENT_ID': {
      backgroundColor: theme.palette.common.white,
      height: 36,
      padding: theme.spacing(1, 2),
      display: 'flex',
      alignItems: 'center'
    }
  },
  cardElementWrapper: {
    ...reskinStyles(theme, {
      border: `1px solid ${theme.colors.form_border_primary}`,
      borderRadius: 23,
      overflow: 'hidden',
      transition: 'border-color 0.15s ease'
    })
  },
  cardElementFocused: {
    ...reskinStyles(theme, {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2
    })
  },
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  errorMessage: {
    fontSize: 11,
    color: theme.palette.error.main
  },
  error: {
    color: theme.palette.error.main
  }
});

export default makeStyles(materialStyles);
